module.exports = __webpack_public_path__ + "img/b4.24d0ba5a.png";